<template>
  <section class="gridClass my-8">
    <slot name="title"></slot>
    <h3
      v-if="!slots.title"
      class="text-xl lg:text-2xl font-bold text-center mb-10"
    >
      {{ details.title }}
    </h3>
    <div class="w-full flex justify-between flex-col lg:flex-row">
      <div
        v-for="item in details.items"
        :key="item.id"
        class="flex flex-col justify-start items-center rounded-xl overflow-hidden mb-6 lg:w-[30%]"
        :class="details.boxClass"
      >
        <NuxtLink :to="item.url" class="w-full text-sm text-center" target="_blank">
          <NuxtImg
            width="1000"
            loading="lazy"
            class="w-full lg:w-[300px] lg:h-[224px] mx-auto mb-4"
            :class="details.imgClass"
            :src="item.img"
            :alt="item.text"
          />
          {{ item.text }}
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useSlots } from "vue";

defineProps({
  details: Object,
});

const slots = useSlots();
</script>
